<div class="page-content">

     <div><button class="btn-back" title="{{Button.Back_alt | translate}}" (click)="onPreviousClick()" translate>{{Button.Previous}}</button></div>

     <h1 class="page-title" translate>{{'birth_certificate_are_you_sure.page_title'}}</h1>

     <div translate="birth_certificate_are_you_sure.text1"></div>

     <div translate="birth_certificate_are_you_sure.text2"></div>
    
     <div class="btn-div">
          <div class="button-top">
               <button [ngClass]="data.subject.language=='fr'?'btn-next4':'btn-next2'"    
                       title="{{'birth_certificate_are_you_sure.return_btn.alt_text'|translate}}" (click)="onPreviousClick()" translate>
                    {{'birth_certificate_are_you_sure.return_btn.label'}}
               </button>
          </div>
          <div class="button-bottom">
               <button [ngClass]="data.subject.language=='fr'?'btn-cancel4':'btn-cancel2'" 
                       title="{{Button.Next_alt|translate}}" (click)="onNextClick()" translate>
                    {{Button.Next}}
               </button>
          </div>
         
     </div>
</div>
